<template>
  <v-row>
    <v-col
        v-for="(current_zona, index) in zonas" :key="index"
        cols="12"
        sm="6"
        md="4"
        class="pt-0 pb-0"
    >
      <v-checkbox
          v-model="selected"
          :label="current_zona.descripcion"
          :value="current_zona.id"
          hide-details
      />
    </v-col>
  </v-row>
</template>

<script>
import {CONSTANTS} from '@/utils/constants'

export default {
  name: 'Zonas',
  data() {
    return {
      zonas: [],
      servicios_zonas: {},
      servicios_zonas_personalizados: [],
      selected: [],
      CONSTANTS: CONSTANTS,
    }
  },

  methods: {
    async get_zonas() {
      const {results} = await this.$store.dispatch('centro/get_zonas', {
        empresa: this.$store.state.centro.centro.empresa,
      })
      this.zonas = results
    },

    /**
     * Crea un map en el que la key es el id del servicio y el value un array de zonas
     */
    parse_servicios_zonas() {
      this.zonas.forEach(current_zona => {
        current_zona.servicios.forEach(current_servicio => {
          if (!this.servicios_zonas[current_servicio]) {
            this.servicios_zonas[current_servicio] = []
          }
          this.servicios_zonas[current_servicio].push(current_zona.id)
        })
      })
    },

    getServiciosZonasPersonalizados(empresaId) {
      switch (empresaId) {
        case CONSTANTS.EMPRESA.IT:
          return [
            {
              servicio_id: 59968, // GAMBE COMPLETE, PIEDI, INGUINE, PUBE, PERIANALE, ASCELLE E VISO O LINEA ALBA
              zonas: [49, 39, 52, 30] // PIERNAS ENTERAS Y PIES - INGLES, PUBIS, PERIANAL - AXILAS - CARA
            },
            {
              servicio_id: 59968, // PIERNAS ENTERAS, PIES, INGLES, PUBIS, PERIANAL, AXILAS Y CARA O LINEA ALBA
              zonas: [49, 39, 52, 43] // PIERNAS ENTERAS Y PIES - INGLES, PUBIS, PERIANAL - AXILAS - LINEA ALBA
            },
            {
              servicio_id: 65680, // MEDIAS PIERNAS, PIES, INGLES, PUBIS, PERIANAL, AXILAS Y CARA O LINEA ALBA
              zonas: [46, 39, 52, 30] // MEDIAS PIERNAS+PIES - INGLES, PUBIS, PERIANAL - AXILAS - CARA
            },
            {
              servicio_id: 65680, // MEDIAS PIERNAS, PIES, INGLES, PUBIS, PERIANAL, AXILAS Y CARA O LINEA ALBA
              zonas: [46, 39, 52, 43] // MEDIAS PIERNAS+PIES - INGLES, PUBIS, PERIANAL - AXILAS - LINEA ALBA
            },
            {
              servicio_id: 66955, // INGLES, PUBIS, PERIANAL, AXILAS, CARA O LINEA ALBA
              zonas: [41, 52, 30] // INGLES, PUBIS, PERIANAL - AXILAS - CARA
            },
            {
              servicio_id: 66955, // INGLES, PUBIS, PERIANAL, AXILAS, CARA O LINEA ALBA
              zonas: [41, 52, 43] // INGLES, PUBIS, PERIANAL - AXILAS - LINEA ALBA
            },
            {
              servicio_id: 66445, // PUBIS,
              zonas: [51] // PUBIS
            }
          ]
        case CONSTANTS.EMPRESA.ES:
          return [
            {
              servicio_id: 168, // PIERNAS ENTERAS, PIES, INGLES, PUBIS, PERIANAL, AXILAS Y CARA O LINEA ALBA
              zonas: [16, 14, 4, 2] // PIERNAS ENTERAS Y PIES - INGLES, PUBIS, PERIANAL - AXILAS - CARA
            },
            {
              servicio_id: 168, // PIERNAS ENTERAS, PIES, INGLES, PUBIS, PERIANAL, AXILAS Y CARA O LINEA ALBA
              zonas: [16, 14, 4, 9] // PIERNAS ENTERAS Y PIES - INGLES, PUBIS, PERIANAL - AXILAS - LINEA ALBA
            },
            {
              servicio_id: 335, // MEDIAS PIERNAS, PIES, INGLES, PUBIS, PERIANAL, AXILAS Y CARA O LINEA ALBA
              zonas: [16, 14, 4, 2] // MEDIAS PIERNAS+PIES - INGLES, PUBIS, PERIANAL - AXILAS - CARA
            },
            {
              servicio_id: 335, // MEDIAS PIERNAS, PIES, INGLES, PUBIS, PERIANAL, AXILAS Y CARA O LINEA ALBA
              zonas: [16, 14, 4, 9] // MEDIAS PIERNAS+PIES - INGLES, PUBIS, PERIANAL - AXILAS - LINEA ALBA
            },
            {
              servicio_id: 502, // INGLES, PUBIS, PERIANAL, AXILAS, CARA O LINEA ALBA
              zonas: [14, 4, 2] // INGLES, PUBIS, PERIANAL - AXILAS - CARA
            },
            {
              servicio_id: 502, // INGLES, PUBIS, PERIANAL, AXILAS, CARA O LINEA ALBA
              zonas: [14, 4, 9] // INGLES, PUBIS, PERIANAL - AXILAS - LINEA ALBA
            },
            {
              servicio_id: 52747, // PUBIS,
              zonas: [25] // PUBIS
            }
          ]
          // Add more cases as needed
        default:
          return [] // Return an empty array or some default value
      }
    }
  },

  async mounted() {
    await this.get_zonas()
    this.parse_servicios_zonas()

    this.servicios_zonas_personalizados = this.getServiciosZonasPersonalizados(
        this.$store.state.centro.centro.empresa)
  },

  watch: {
    'selected': function (new_value) {
      if (new_value.length === 0) {
        this.$emit('on_servicios_encontrados', null)
        return
      }

      let empresaId = this.$store.state.centro.centro.empresa
      const ZONA_GENITALES_MASCULINOS_ID = empresaId === CONSTANTS.EMPRESA.IT ? 35 : 17
      const SERVICIO_GENITALES_MASCULINOS_ID = empresaId === CONSTANTS.EMPRESA.IT ? 60427 : 6860

      let zonas_seleccionadas = this.zonas.filter(function (z) {
        return new_value.includes(z.id)
      }).map((z) => z.id)
      let is_genitales_masculinos = zonas_seleccionadas.includes(ZONA_GENITALES_MASCULINOS_ID)

      // Si hay varias zonas seleccionadas y se incluye los genitales masculinos, lo sacamos del array para añadirlo manualmente
      const sacar_zona_genitales_masculinos = zonas_seleccionadas.length > 1 && is_genitales_masculinos
      if (sacar_zona_genitales_masculinos) {
        const index = zonas_seleccionadas.indexOf(ZONA_GENITALES_MASCULINOS_ID)
        if (index !== -1) {
          zonas_seleccionadas.splice(index, 1)
        }
      }

      let respuesta = []
      // Buscamos si algún servicio incluye las zonas seleccionadas
      for (let servicio_id of Object.keys(this.servicios_zonas)) {
        if (zonas_seleccionadas.sort().join(',') === this.servicios_zonas[servicio_id].sort().join(',')) {
          respuesta.push(parseInt(servicio_id))
        } else {
          // Buscamos si está en servicios personalizados
          this.servicios_zonas_personalizados.forEach((current) => {
            if (zonas_seleccionadas.sort().join(',') === current['zonas'].sort().join(',')) {
              respuesta.push(parseInt(current['servicio_id']))
            }
          })
        }
      }

      // Si hemos sacado la zona de genitales masculino s y las zonas seleccionadas ya incluyen algún servicio, lo incluimos en la respuesta
      if (sacar_zona_genitales_masculinos && respuesta.length > 0) {
        respuesta.push(SERVICIO_GENITALES_MASCULINOS_ID)
      }
      this.$emit('on_servicios_encontrados', respuesta)
    }
  }

}
</script>
